// extracted by mini-css-extract-plugin
export default {"sidebar":"LeftSidebar_sidebar__pIFyU","sidebar__links":"LeftSidebar_sidebar__links__XrSQe","sidebar__link":"LeftSidebar_sidebar__link__x+mP3"};